import { DmdpErrorCodeType } from '@csp/csp-common-model/src/lib/fault/error/DmdpErrorCodeType';
import { BioSampleErrorCodeType } from '@csp/csp-common-hbs-model';
import { Maybe } from '@csp/csp-common-model';
import { EnumUtil } from '@csp/csp-common-enum-util';

const fromDmdpErrorCode = (dmdpCode: Maybe<string>): BioSampleErrorCodeType => {
  const dmdpCodeType: Maybe<DmdpErrorCodeType> = EnumUtil.fromMaybeString(dmdpCode, DmdpErrorCodeType);
  return dmdpCodeType ? fromDmdpErrorCodeType(dmdpCodeType) : BioSampleErrorCodeType.UNEXPECTED;
};

const fromDmdpErrorCodeType = (dmdpCode: DmdpErrorCodeType): BioSampleErrorCodeType => {
  switch (dmdpCode) {
    case DmdpErrorCodeType.DMDP_CONFLICT:
      return BioSampleErrorCodeType.DUPLICATE_SAMPLE;
    case DmdpErrorCodeType.DMDP_BAD_ARGUMENT:
      return BioSampleErrorCodeType.INVALID_ARGUMENT;
    case DmdpErrorCodeType.DMDP_RESOURCE_NOT_FOUND:
      return BioSampleErrorCodeType.SAMPLE_NOT_FOUND;
    case DmdpErrorCodeType.DMDP_AUTHORIZATION_FAILED:
      return BioSampleErrorCodeType.UNEXPECTED;
    default:
      return BioSampleErrorCodeType.UNEXPECTED;
  }
};

export const BioSampleErrorCodeMapper = {
  fromDmdpErrorCode,
  fromDmdpErrorCodeType,
};
